import { render } from "./MacOSAppstoreUpgrade.vue?vue&type=template&id=40727624&scoped=true"
import script from "./MacOSAppstoreUpgrade.vue?vue&type=script&lang=js"
export * from "./MacOSAppstoreUpgrade.vue?vue&type=script&lang=js"

import "./MacOSAppstoreUpgrade.vue?vue&type=style&index=0&id=40727624&scoped=true&lang=css"

import exportComponent from "/workspace/goj/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40727624"]])

export default __exports__